import styled from 'styled-components';

export const OfflineTestWrapper = styled.div`
  display: flex;
  position: relative;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;
